export const Loading = () => (
  <section className="aspect-video w-full min-h-screen" />
);
